import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ProjectsSection = () => {
  const { t } = useTranslation();
  const projectsData = t("mainProjects", { returnObjects: true });
  const projects = Array.isArray(projectsData) 
    ? (projectsData as Array<{
        title: string;
        description: string;
      }>)
    : [];
  
  // Images remain static (same for all languages)
  const projectImages = [
    {
      bigImage: "yassy-big.png",
      smallImage: "yassy-small.png",
    },
    {
      bigImage: "ps-zhuldyz-big.png",
      smallImage: "ps-zhuldyz-small.png",
    },
    {
      bigImage: "asia-trafo-big.png",
      smallImage: "asia-trafo-small.png",
    },
    {
      bigImage: "zhk-alageum-electric-big.png",
      smallImage: "zhk-alageum-electric-small.png",
    },
    {
      bigImage: "ps-sez-big.png",
      smallImage: "ps-sez-small.png",
    },
    {
      bigImage: "ps-arai-big.png",
      smallImage: "ps-arai-small.png",
    },
  ];
  return (
    <section id="projects" className="w-full">
      <div
        className="bg-white flex h-[185px] items-center justify-center w-full text-[#851919] font-['Forum'] text-[30px] font-normal uppercase leading-[36px] md:leading-[75px]"
        style={{
          leadingTrim: "both",
          textEdge: "cap",
        } as React.CSSProperties & { leadingTrim?: string; textEdge?: string }}
      >
        {t("projectsSection.title")}
      </div>
      {projects.map((project, i) => {
        const images = projectImages[i];
        if (!images) return null;
        
        return (
        <div
          key={i}
          className="relative w-full h-[800px] lg:h-[810px] overflow-hidden bg-cover bg-center"
          style={{
            backgroundImage: `url('/${images.bigImage}')`,
          }}
        >
          <div className="opacity-90 bg-red-900 inset-x-[30px] top-1/2 -translate-y-1/2 lg:inset-[150px] lg:translate-y-0 absolute flex items-center justify-center">
            <div className="w-full h-full flex flex-col lg:flex-row lg:p-[40px] p-[30px]">
              <div className="flex flex-col flex-grow order-1 lg:order-1 lg:p-[40px]">
                <div>
                  <div className="font-['Forum'] text-[24px] lg:text-[36px] mb-[20px] lg:mb-[30px] font-normal leading-[28px] lg:leading-[48px] text-white uppercase">
                    {project.title}
                  </div>
                  <p className="font-['Inter'] text-[14px] font-light leading-[16px] text-white lg:pr-[40px]">
                    {project.description}
                  </p>
                </div>
                <div className="hidden lg:block lg:mt-auto">
                  <Link
                    to="/projects"
                    className="w-[275px] h-[60px] flex justify-center items-center bg-red-900 text-[#FFF] text-[16px] border border-white"
                  >
                    {t("projectsSection.viewProject")}
                  </Link>
                </div>
              </div>

              <div className="order-2 lg:order-2 lg:w-1/2 h-full my-5 lg:my-0">
                <div className="bg-cover bg-center lg:h-full aspect-square ">
                  <img
                    src={`/${images.smallImage}`}
                    alt={project.title}
                    className="h-full object-cover"
                  />
                </div>
              </div>

              <div className="order-3 lg:hidden">
                <Link
                  to="/projects"
                  className=" h-[55px] flex justify-center items-center bg-red-900 text-[#FFF] text-[14px] font-['Inter'] font-normal border border-white"
                >
                  {t("projectsSection.viewProject")}
                </Link>
              </div>
            </div>
          </div>
        </div>
        );
      })}
    </section>
  );
};

export default ProjectsSection;
